import { render } from "./OptionsDialog.vue?vue&type=template&id=07406b5c&scoped=true&ts=true"
import script from "./OptionsDialog.vue?vue&type=script&lang=ts"
export * from "./OptionsDialog.vue?vue&type=script&lang=ts"

import "./OptionsDialog.vue?vue&type=style&index=0&id=07406b5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07406b5c"]])

export default __exports__